import React from 'react';
import { GetServerSidePropsContext } from 'next';
import LayoutApp from '@zmedia/bm-soccer-ui/layout';
import { PlayerPageView } from '@zmedia/bm-soccer-ui/modules/player';
import PageCustomService from '@zmedia/bm-soccer-ui/service/PageCustomService';
import { IResponse } from 'src/interface';
import { ContainerUI } from 'src/layout/ui';
import { ContentItem } from 'src/modules/content/components/item/ContentItem';

export function PlayerPage({
    resp,
    isBot,
}: {
    resp: IResponse<any>;
    isBot: boolean;
}) {
    const { data } = resp;
    const listProps = {
        ContentItem: ContentItem,
        ContentItemProps: {
            lazyloadImage: !isBot,
        },
    };
    return (
        <>
            <ContainerUI {...data} />
            <LayoutApp isMobile={true} {...data}>
                <PlayerPageView {...data} listProps={listProps} />
            </LayoutApp>
        </>
    );
}

export async function getServerSideProps(
    ctx: GetServerSidePropsContext
): Promise<any> {
    const id = ctx?.params?.id;
    const tab = ctx?.params?.tab;
    const resp = await PageCustomService.get(ctx, 'player', {
        id: id,
        tab: tab,
    });
    return {
        props: {
            ...resp.props,
            isBlankLayout: true,
        },
    };
}

export default PlayerPage;
